import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6978103e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col px-2 pb-2 gap-3 bg-gray-100 rounded-lg border border-gray-200 shadow-sm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between px-2 text-gray-500" }, null, -1))
const _hoisted_3 = { class: "flex flex-col gap-2 p-2 bg-white rounded-md shadow-sm" }
const _hoisted_4 = ["onMouseover", "onMouseleave"]
const _hoisted_5 = { class: "flex gap-2 items-center text-sm" }
const _hoisted_6 = { class: "text-gray-700 font-semibold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "in", -1))
const _hoisted_8 = { class: "flex flex-wrap gap-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "in", -1))
const _hoisted_10 = { class: "flex flex-wrap gap-2" }
const _hoisted_11 = { class: "text-gray-500" }
const _hoisted_12 = {
  key: 0,
  class: "flex gap-x-2"
}
const _hoisted_13 = {
  key: 0,
  class: "filter-value"
}
const _hoisted_14 = {
  key: 1,
  class: "flex gap-x-2 justify-center"
}
const _hoisted_15 = { class: "filter-value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-", -1))
const _hoisted_17 = { class: "filter-value" }
const _hoisted_18 = {
  key: 2,
  class: "flex gap-x-2"
}
const _hoisted_19 = { class: "filter-value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-", -1))
const _hoisted_21 = { class: "filter-value" }
const _hoisted_22 = {
  key: 3,
  class: "flex gap-x-2"
}
const _hoisted_23 = {
  key: 1,
  class: "filter-value"
}
const _hoisted_24 = {
  key: 0,
  class: "flex gap-2 items-center"
}
const _hoisted_25 = { class: "flex justify-between" }

import { computed, ref } from "vue"
import GgmsChip from "@/components/GgmsChip.vue"
import { Filter } from "@/shared/models/filter"
import { displayFilterValue, displayFilterRule, convertValue, displayVisibility } from "@/shared/utils/helpers"
import { PencilIcon, TrashIcon } from "@heroicons/vue/outline"
import { useTagStore } from "@/stores/tag"
import { useOriginStore } from "@/stores/origin"

interface Props {
    groupIndex: number
    filters: Filter[]
    groupsLength: number
    justDisplay?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterGroup',
  props: {
    groupIndex: {},
    filters: {},
    groupsLength: {},
    justDisplay: { type: Boolean, default: false }
  },
  emits: ["removeGroup", "addNewFilterToGroup", "editFilter", "removeFilter"],
  setup(__props: any, { emit: __emit }) {

const tagStore = useTagStore()
const originStore = useOriginStore()

const props = __props
const emit = __emit

const iconVisibility = ref(new Array(props.filters.length).fill(false))

const isOnlyOneGroup = computed(() => props.groupsLength === 1)
const cachedTags = computed(() => tagStore.cachedTags)
const cachedOrigins = computed(() => originStore.cachedOrigins)

function getTagsByFilterIds(filter: Filter) {
    return tagStore.tableState.data.filter((tag) => (filter.value as string[])?.includes(tag._id))
}

function getOriginsByFilterIds(filter: Filter) {
    return originStore.tableState.data.filter((origin) => (filter.value as string[])?.includes(origin._id))
}

function removeGroup() {
    emit("removeGroup", props.groupIndex)
}

function addNewFilterToGroup() {
    emit("addNewFilterToGroup", props.groupIndex)
}

function removeFilter(filterIndex: number) {
    emit("removeFilter", props.groupIndex, filterIndex)
}

function editFilter(filter: Filter, filterIndex: number) {
    emit("editFilter", filter, props.groupIndex, filterIndex)
}

function setIconVisibility(filterIndex: number, isVisible: boolean) {
    iconVisibility.value[filterIndex] = isVisible
}

function checkIsArray(value?: string | string[] | Date) {
    return Array.isArray(value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, filterIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: filter.field,
          class: "flex gap-2 items-center justify-between text-sm cursor-pointer hover:bg-gray-100 rounded-md px-2 py-1",
          onMouseover: ($event: any) => (setIconVisibility(filterIndex, true)),
          onMouseleave: ($event: any) => (setIconVisibility(filterIndex, false))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(filter.displayName), 1),
            (filter.displayName === 'Tags')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTagsByFilterIds(filter), (tag) => {
                      return (_openBlock(), _createBlock(GgmsChip, {
                        key: tag._id,
                        bgColor: cachedTags.value[tag._id]?.backgroundColor,
                        textColor: cachedTags.value[tag._id]?.foregroundColor,
                        isRemovable: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["bgColor", "textColor"]))
                    }), 128))
                  ])
                ], 64))
              : (filter.displayName === 'Origins')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOriginsByFilterIds(filter), (origin) => {
                        return (_openBlock(), _createBlock(GgmsChip, {
                          key: origin._id,
                          bgColor: cachedOrigins.value[origin._id]?.backgroundColor,
                          textColor: cachedOrigins.value[origin._id]?.foregroundColor,
                          isRemovable: false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(origin.displayName), 1)
                          ]),
                          _: 2
                        }, 1032, ["bgColor", "textColor"]))
                      }), 128))
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(displayFilterRule)(filter.rule)), 1),
                    (checkIsArray(filter.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (filter?.rule === 'isInIds')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(displayFilterValue)(filter.value[0]).slice(0, 30) + "..."), 1))
                            : (filter.type === 'Date')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(displayFilterValue)(
                                            filter.value[0],
                                            filter.type === "Date",
                                            filter.displayName === "Due Date & Time"
                                        )), 1),
                                  _hoisted_16,
                                  _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(displayFilterValue)(
                                            filter.value[1],
                                            filter.type === "Date",
                                            filter.displayName === "Due Date & Time"
                                        )), 1)
                                ]))
                              : (filter.type === 'number' && checkIsArray(filter.value))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(filter.value[0]), 1),
                                    _hoisted_20,
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(filter.value[1]), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.value, (value, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "filter-value"
                                      }, _toDisplayString(_unref(displayFilterValue)(
                                            value,
                                            false,
                                            false,
                                            ["type", "typeName"].includes(filter.field),
                                            filter.rule === "isIn"
                                        )), 1))
                                    }), 128))
                                  ]))
                        ]))
                      : (filter.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(displayFilterValue)(
                                    Array.isArray(filter.value) ? String(filter.value[0]) : String(filter.value),
                                    filter.type === "Date",
                                    ["Due Date & Time", "Last Updated At", "Created At"].includes(
                                        filter.displayName ?? ""
                                    ),
                                    ["type", "typeName"].includes(filter.field),
                                    filter.rule === "isIn",
                                    filter.field === "reminder"
                                )), 1))
                        : _createCommentVNode("", true)
                  ], 64))
          ]),
          (iconVisibility.value[filterIndex] && !_ctx.justDisplay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_unref(PencilIcon), {
                  class: "h-5 w-5 text-gray-400 hover:text-gray-500",
                  onClick: _withModifiers(($event: any) => (editFilter(filter, filterIndex)), ["prevent","stop"])
                }, null, 8, ["onClick"]),
                (_ctx.filters.length > 1)
                  ? (_openBlock(), _createBlock(_unref(TrashIcon), {
                      key: 0,
                      class: "h-5 w-5 text-gray-400 hover:text-gray-500",
                      onClick: _withModifiers(($event: any) => (removeFilter(filterIndex)), ["prevent","stop"])
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 40, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_25, [
      (!_ctx.justDisplay)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "px-2 bg-primary-color-600 text-white rounded w-fit cursor-pointer",
            onClick: _withModifiers(addNewFilterToGroup, ["stop"])
          }, " AND "))
        : _createCommentVNode("", true),
      (!isOnlyOneGroup.value && !_ctx.justDisplay)
        ? (_openBlock(), _createBlock(_unref(TrashIcon), {
            key: 1,
            class: "h-5 w-5 text-gray-400 hover:text-gray-500 cursor-pointer",
            onClick: _withModifiers(removeGroup, ["stop"])
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})